<template>
    <div>
        <ad-agency-commission-icon :ad="ad"></ad-agency-commission-icon>

        <ad-third-party-costs-icon :ad="ad"></ad-third-party-costs-icon>
    </div>
</template>

<script>
    import AdAgencyCommissionIcon from '@/components/Icons/AdAgencyCommissionIcon'
    import AdThirdPartyCostsIcon from '@/components/Icons/AdThirdPartyCostsIcon'

    export default {
        components: {AdAgencyCommissionIcon, AdThirdPartyCostsIcon},

        props: {
            ad: {
                type: Object,
                required: true
            }
        }
    }
</script>
